export default "__VITE_ASSET__S$DNcyGH__"